import { Injectable } from '@angular/core';
import {ApiService, EnvironmentModel} from '@cas-hub/acabim-common-client';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {OrganisationPreferenceModel, OrganisationPreferencesModel} from '../../_models/organisation/organisation-preferences.model';

@Injectable({
  providedIn: 'root'
})
export class OrganisationPreferencesService extends ApiService {

  protected controller = 'organisation/preferences';

  constructor(
      protected client: HttpClient,
      protected environment: EnvironmentModel
  ) {
    super(client, environment);
  }

  public getPreferences(): Observable<OrganisationPreferencesModel> {
    return this.client.get<OrganisationPreferencesModel>(this.url('')).pipe(map(data => {
      return data;
    }));
  }

  public getSetupRuns(): Observable<number> {
    return this.client.get<number>(this.url('setup')).pipe(map(data => {
      return data;
    }));
  }

  public setSetupRuns(): Observable<number> {
    return this.client.post<number>(this.url('setup'), {}).pipe(map(data => {
      return data;
    }));
  }

  public updatePreference(preferenceType: string, preferenceValue: boolean | string): Observable<OrganisationPreferencesModel> {
    let body = null;
    if (typeof preferenceValue === 'boolean') {
      body = OrganisationPreferencesService.handlePreference(preferenceType, preferenceValue);
    } else {
      body = OrganisationPreferencesService.handleStringPreference(preferenceType, preferenceValue);
    }
    return this.client.post<OrganisationPreferencesModel>(this.url(''), body).pipe(map(data => {
      return data;
    }));
  }

  private static handlePreference(preferenceType: string, preferenceValue: boolean): OrganisationPreferenceModel | null {
    switch (preferenceType) {
      case 'run_action_tasks':
        return {run_action_tasks: preferenceValue};
      case 'run_generate_assets_task':
        return {run_generate_assets_task: preferenceValue};
      case 'run_import_project_ltms_task':
        return {run_import_project_ltms_task: preferenceValue};
      case 'branding_banner':
        return {branding_banner: preferenceValue};
      default:
        return null;
    }
  }

  private static handleStringPreference(preferenceType: string, preferenceValue: string): OrganisationPreferenceModel | null {
    switch (preferenceType) {
      case 'branding_banner_colour':
        return {branding_banner_colour: preferenceValue};
      case 'branding_text_colour':
        return {branding_text_colour: preferenceValue};
      default:
        return null;
    }
  }
}
